import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  showNavBar = true;
  showFooter = true;

  constructor(private router: Router) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: any) => {
      if (
        environment.hideNavBarAndFooterUrls.indexOf(
          (event as unknown as NavigationEnd).urlAfterRedirects.split('?')[0]
        ) > -1
      ) {
        this.showNavBar = false;
        this.showFooter = false;
      } else {
        this.showNavBar = true;
        this.showFooter = true;
      }
    });
  }
}
